export default "__VITE_ASSET__7JYhFBzq__"